// extracted by mini-css-extract-plugin
export var container = "postCategories-module--container--UjL7b";
export var anchor = "postCategories-module--anchor--ZX8Ea";
export var title = "postCategories-module--title--2Wffv";
export var title_text = "postCategories-module--title_text--iUmSM";
export var marker = "postCategories-module--marker--3fewY";